export default __webpack_public_path__ + "static/greeff-34991f194853b79ed3f3d770d9c3a74d.jpg";